var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isGroup && !_vm.storeId)?_c('group-discount-list'):_c('store-discount-lists')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }